export default 
{   
    "Auto Parts":{
        "Car Parts":{
            "Body Parts & Framework":0,
            "Doors":0,
            "Windows":0,
            "Audio/Video Devices":0,
            "Cameras":0,
            "Electrical Supply System":0,
            "Gauges & Meters":0,
            "Ignition Electronic System":0,
            "Lighting & Signaling System":0,
            "Sensors":0,
            "Starting System":0,
            "Electrical Switches":0,
            "Wiring Harnesses":0,
            "Floor Components & Parts":0,
            "Seat Sets":0,
            "Tyres & Rims":0,
            "Dashboard & Interior Items":0,
            "Braking System":0,
            "Engine Components & Parts":0,
            "Engine Cooling System":0,
            "Engine Oil Systems":0,
            "Exhaust System":0,
            "Fuel Supply System":0,
            "Suspension & Steering Systems":0,
            "Transmission System":0,
            "Air Conditioning System (A/C)":0,
            "Bearings":0,
            "Hose":0,
            "Other Miscellaneous Parts":0
        },
        "Motocycle Parts":{
            "Proctive Equipments":0,
            "Exhausts":0,
            "Body Works":0,
            "Engine Parts":0,
            "Handles & Control Parts":0,
            "Drive Parts":0,
            "Brakes":0,
            "Electrical":0,
            "Framework":0,
            "Suspension":0,
            "Reaersets":0,
            "Wheels":0,
            "Swingarms":0,
            "Tyres":0,
            "Other Miscellaneous Parts":0
        },
        "Three Wheeler Parts":{
            "Body Parts& Framework":0,
            "Doors":0,
            "Windows":0,
            "Audio/Video Devices":0,
            "Cameras":0,
            "Electrical Supply System":0,
            "Gauges & Meters":0,
            "Ignition Electronic System":0,
            "Lighting & Signaling System":0,
            "Sensors":0,
            "Starting System":0,
            "Electrical Switches":0,
            "Wiring Harnesses":0,
            "Floor Components & Parts":0,
            "Seat Sets":0,
            "Tyres & Rims":0,
            "Dashboard & Interior Items":0,
            "Braking System":0,
            "Engine Components & Parts":0,
            "Engine Cooling System":0,
            "Engine Oil Systems":0,
            "Exhaust System":0,
            "Fuel Supply System":0,
            "Suspension & Steering Systems":0,
            "Transmission System":0,
            "Air Conditioning System (A/C)":0,
            "Bearings":0,
            "Hose":0,
            "Other Miscellaneous Parts":0
        },
        "Bus Parts":{
            "Body Parts& Framework":0,
            "Doors":0,
            "Windows":0,
            "Audio/Video Devices":0,
            "Cameras":0,
            "Electrical Supply System":0,
            "Gauges & Meters":0,
            "Ignition Electronic System":0,
            "Lighting & Signaling System":0,
            "Sensors":0,
            "Starting System":0,
            "Electrical Switches":0,
            "Wiring Harnesses":0,
            "Floor Components & Parts":0,
            "Seat Sets":0,
            "Tyres & Rims":0,
            "Dashboard & Interior Items":0,
            "Braking System":0,
            "Engine Components & Parts":0,
            "Engine Cooling System":0,
            "Engine Oil Systems":0,
            "Exhaust System":0,
            "Fuel Supply System":0,
            "Suspension & Steering Systems":0,
            "Transmission System":0,
            "Air Conditioning System (A/C)":0,
            "Bearings":0,
            "Hose":0,
            "Other Miscellaneous Parts":0
        },
        "Lorry Parts":{
            "Body Parts& Framework":0,
            "Doors":0,
            "Windows":0,
            "Audio/Video Devices":0,
            "Cameras":0,
            "Electrical Supply System":0,
            "Gauges & Meters":0,
            "Ignition Electronic System":0,
            "Lighting & Signaling System":0,
            "Sensors":0,
            "Starting System":0,
            "Electrical Switches":0,
            "Wiring Harnesses":0,
            "Floor Components & Parts":0,
            "Seat Sets":0,
            "Tyres & Rims":0,
            "Dashboard & Interior Items":0,
            "Braking System":0,
            "Engine Components & Parts":0,
            "Engine Cooling System":0,
            "Engine Oil Systems":0,
            "Exhaust System":0,
            "Fuel Supply System":0,
            "Suspension & Steering Systems":0,
            "Transmission System":0,
            "Air Conditioning System (A/C)":0,
            "Bearings":0,
            "Hose":0,
            "Other Miscellaneous Parts":0
        },
        "Tipper Parts":{
            "Body Parts& Framework":0,
            "Doors":0,
            "Windows":0,
            "Audio/Video Devices":0,
            "Cameras":0,
            "Electrical Supply System":0,
            "Gauges & Meters":0,
            "Ignition Electronic System":0,
            "Lighting & Signaling System":0,
            "Sensors":0,
            "Starting System":0,
            "Electrical Switches":0,
            "Wiring Harnesses":0,
            "Floor Components & Parts":0,
            "Seat Sets":0,
            "Tyres & Rims":0,
            "Dashboard & Interior Items":0,
            "Braking System":0,
            "Engine Components & Parts":0,
            "Engine Cooling System":0,
            "Engine Oil Systems":0,
            "Exhaust System":0,
            "Fuel Supply System":0,
            "Suspension & Steering Systems":0,
            "Transmission System":0,
            "Air Conditioning System (A/C)":0,
            "Bearings":0,
            "Hose":0,
            "Other Miscellaneous Parts":0
        },
        "Truck Parts":{
            "Body Parts& Framework":0,
            "Doors":0,
            "Windows":0,
            "Audio/Video Devices":0,
            "Cameras":0,
            "Electrical Supply System":0,
            "Gauges & Meters":0,
            "Ignition Electronic System":0,
            "Lighting & Signaling System":0,
            "Sensors":0,
            "Starting System":0,
            "Electrical Switches":0,
            "Wiring Harnesses":0,
            "Floor Components & Parts":0,
            "Seat Sets":0,
            "Tyres & Rims":0,
            "Dashboard & Interior Items":0,
            "Braking System":0,
            "Engine Components & Parts":0,
            "Engine Cooling System":0,
            "Engine Oil Systems":0,
            "Exhaust System":0,
            "Fuel Supply System":0,
            "Suspension & Steering Systems":0,
            "Transmission System":0,
            "Air Conditioning System (A/C)":0,
            "Bearings":0,
            "Hose":0,
            "Other Miscellaneous Parts":0
        },
        "Jeep & Picup Parts":{
            "Body Parts& Framework":0,
            "Doors":0,
            "Windows":0,
            "Audio/Video Devices":0,
            "Cameras":0,
            "Electrical Supply System":0,
            "Gauges & Meters":0,
            "Ignition Electronic System":0,
            "Lighting & Signaling System":0,
            "Sensors":0,
            "Starting System":0,
            "Electrical Switches":0,
            "Wiring Harnesses":0,
            "Floor Components & Parts":0,
            "Seat Sets":0,
            "Tyres & Rims":0,
            "Dashboard & Interior Items":0,
            "Braking System":0,
            "Engine Components & Parts":0,
            "Engine Cooling System":0,
            "Engine Oil Systems":0,
            "Exhaust System":0,
            "Fuel Supply System":0,
            "Suspension & Steering Systems":0,
            "Transmission System":0,
            "Air Conditioning System (A/C)":0,
            "Bearings":0,
            "Hose":0,
            "Other Miscellaneous Parts":0
        },
        "Van Parts":{
            "Body Parts& Framework":0,
            "Doors":0,
            "Windows":0,
            "Audio/Video Devices":0,
            "Cameras":0,
            "Electrical Supply System":0,
            "Gauges & Meters":0,
            "Ignition Electronic System":0,
            "Lighting & Signaling System":0,
            "Sensors":0,
            "Starting System":0,
            "Electrical Switches":0,
            "Wiring Harnesses":0,
            "Floor Components & Parts":0,
            "Seat Sets":0,
            "Tyres & Rims":0,
            "Dashboard & Interior Items":0,
            "Braking System":0,
            "Engine Components & Parts":0,
            "Engine Cooling System":0,
            "Engine Oil Systems":0,
            "Exhaust System":0,
            "Fuel Supply System":0,
            "Suspension & Steering Systems":0,
            "Transmission System":0,
            "Air Conditioning System (A/C)":0,
            "Bearings":0,
            "Hose":0,
            "Other Miscellaneous Parts":0
        },
        "Heavy-Duty & Machinery Parts":{
            "Body Parts& Framework":0,
            "Doors":0,
            "Windows":0,
            "Audio/Video Devices":0,
            "Cameras":0,
            "Electrical Supply System":0,
            "Gauges & Meters":0,
            "Ignition Electronic System":0,
            "Lighting & Signaling System":0,
            "Sensors":0,
            "Starting System":0,
            "Electrical Switches":0,
            "Wiring Harnesses":0,
            "Floor Components & Parts":0,
            "Seat Sets":0,
            "Tyres & Rims":0,
            "Hydraulic System":0,
            "Trailers":0,
            "Stabilizer":0,
            "Boom":0,
            "Compressor":0,
            "Dashboard & Interior Items":0,
            "Braking System":0,
            "Engine Components & Parts":0,
            "Engine Cooling System":0,
            "Engine Oil Systems":0,
            "Exhaust System":0,
            "Fuel Supply System":0,
            "Suspension & Steering Systems":0,
            "Transmission System":0,
            "Air Conditioning System (A/C)":0,
            "Bearings":0,
            "Hose":0,
            "Other Miscellaneous Parts":0
        },
    },


    "Baby Kids & Toys":{
        "Baby Cosmetics":{
            "Powders and talc":0,
            "Oils":0,
            "Nappy Care":0,
            "Lotions and Creams":0,
            "Healthy Teeth":0,
            "Bath Time":0,
            "Other Baby Cosmetics":0
        },

        "Fresh and Cuddly":{
            "Wet Wipes":0,
            "Toilet Trainers":0,
            "Grooming Items":0,
            "Diapers":0,
            "Baby Detergents":0,
            "Other Fresh and Cuddly":0
        },
        "Furniture":{
            "Playmats & Playpens":0,
            "Baby Cupboards & Storage":0,
            "Baby Cot":0,
            "Chair & Desks":0,
            "Baby Swings":0,
            "Other Furniture":0
        },

        "Baby Gear":{
            "Baby Bath":0,
            "Car Seat":0,
            "Bouncers,Rockers & Cradles":0,
            "Baby Carrier":0,
            "Feeding Chair":0,
            "Baby Strollers & Go Carts":0,
            "Baby Walkers":0,
            "Other Baby Gear":0
        },
        "Toys":{
            "Activity Gyms & Play Gyms":0,
            "Tricycles":0,
            "Rechargeable Electric Cars":0,
            "Rechargeable Electric Motorbikes":0,
            "Ride on Cars":0,
            "Kids Scooter":0,
            "Crib & Cot Toys":0,
            "Rocking Horse":0,
            "Toys (Educational)":0,
            "Other Toys":0
        },
     },

     "Bags":{
        "Bags":{
            "Women’s Handbags":0,
            "Side Bags":0,
            "Totes & Shoppers":0,
            "Cosmetic Bags":0,
            "Office Bag":0,
            "School Bags":0,
            "Other Bags":0
        },
     },

     "Books":{
        "A/L Books":{
            "Science":0,
            "Maths":0,
            "Commerce":0,
            "Arts":0,
            "Technology":0,
            "Pass Papers":0
        },
        "Grades":{
            "O/L Pass Papers":0,
            "Grade 11 to 6":0,
            "Grade 5 Schoolarship":0, 
            "Grade 5 to 1":0,
            "Pre School":0
        },
        "Novels":{
            "Short Stories":0,
            "Translated":0,
            "Horror":0,
            "Sci-Fi & Fantasy":0,
            "Romance":0,
            "Mysteries":0,
            "Other Novels":0 
           },

        "Other Categories":{
            "Arts":0, 
            "Music":0,
            "History":0,
            "Higher Education":0,
            "Biographies":0,
            "Business":0,
            "Kids":0,
            "Computers & Tech":0, 
            "Cooking":0,
            "Hobbies & Crafts":0,  
            "Health & Fitness":0,
            "Home & Garden":0,
            "Entertainment":0, 
            "Literature & Fiction":0, 
            "Medical":0,
            "Parenting":0,
            "Social Science":0, 
            "Religious":0,
            "Science":0,
            "Self-Help":0,
            "Sports":0, 
            "Crime":0,
            "Western":0, 
            "Languages":0,
            "Buddhism":0,
            "Accountig & Marketing":0,
            "Agriculture":0,
            "Archaeology":0,
            "Astrology":0,
            "Astronomy":0, 
            "Ayurwedaya & Yoga":0,
            "Dictionaries":0, 
            "Dancing":0,
            "Drama":0,
            "Economics, Finance & Law":0,
            "Electronic":0,
            "General Knowledge":0,
            "Human Resource Management":0,
            "Philosophy":0, 
            "Poetry":0,
            "Politics":0, 
            "Psychology":0,
            "Travel and Tourism":0,
            "Other":0  
        },
    },

    "Cameras":{
        "Cameras":{
            "Security Cameras":0, 
            "DSLR & Mirrorless Cameras":0, 
            "Digital Cameras":0, 
            "Drones":0,
            "Camcorders":0, 
            "Instant Cameras":0,
            "Other Cameras":0 

            },

        "Camera Accessories":{
            "Lenses":0, 
            "Lens Hood":0,
            "Filters":0,
            "Flashes":0, 
            "Camera Tripods":0,
            "Camera Batteries":0,
            "Digital Photo Frames":0,
            "Camera Bags":0,
            "Lens Caps":0,
            "Binoculars & Optics":0,
            "Triggers":0,
            "Audio & Video Accessories":0,
            "Lens Cleaner":0,
            "Camera Monopods":0,
            "Straps":0,
            "Memory Cards":0,
            "Screen Guards":0,
            "Camera Remote Controllers":0,
            "Other Camera Accessories":0
        },

        "Binoculars & Telescopes":{
        "Binoculars & Telescopes":0
        },
    },

    "Computers":{
        "Desktops":{
            "Apple Desktops":0,
            "Other Desktops":0
           

        },

        "Laptops":{
            "Acer":0,
            "Apple":0,
            "ASUS":0,
            "Dell":0,
            "HP":0,
            "Huawei":0,
            "Lenovo":0,
            "Microsoft":0,
            "MSI":0,
            "Razer":0,
            "Samsung":0,
            "Singer":0,
            "Toshiba":0,
            "Other Laptops":0,
        },

        "Laptop & Desktop Accessories":{
            "Keyboards & Mouses":0,
            "Headphones & Speakers":0, 
            "Cables & Interconnects":0,
            "Printers":0,
            "Scanners":0,
            "Monitors":0,
            "Projectors":0,
            "Memory Cards":0,
            "USB Flash Drives":0,
            "Routers & Modems":0,
            "Docking Stations":0,
            "Laptop Bags":0,
            "Chargers & Adapters":0,
            "Cooling Pads":0,
            "Stands":0,
            "Screen Protectors":0,
            "Other Laptop & Desktop Accessories":0 
        },
                

        "PC Components":{
            "Cases":0,
            "CD/DVD Drives":0,
            "CPU Processors":0,
            "Fans & Cooling":0,
            "Graphics Cards":0,
            "Memory":0,
            "Motherboards":0,
            "Network Cards":0,
            "Power Supplies":0,
            "Softwares":0,
            "Soundcards":0,
            "Solid State Drives":0,
            "External Hard Drives":0,
            "Internal Hard Drives":0,
            "Hard Drives for Mac":0,
            "Other PC Components":0
            },
    },

    "Diamonds & Gems":{
        "Diamonds & Gemstones":{
            "Stone":0,
            "Metals":0,
            "Crystals":0,
            "Rhinestone":0,
            "Vintage":0,
            "Fused Glass":0,
            "Other Diamonds & Gemstones":0
        },
    },

    "Electronics":{
        "Home Electronics":{
            "TV":0,
            "Air Conditioning":0, 
            "Heaters":0,
            "Washing Machine":0,
            "Ions":0,
            "Refrigerators & Freezers":0,
            "Fans":0,
            "Home Theater":0,
            "Hi-Fi & Stereo":0,
            "Speakers":0,
            "Vacuum Cleaners":0,
            "DVD & BLU-RAY Players":0,
            "Torch & Portable Lamps":0,
            "Other Home Electronics":0
        },
        "Kitchen Electronics":{
            "Electronic Oven":0,
            "Gas Cookers":0,
            "Toasters & Waffle Makers":0,
            "Kettles":0,
            "Water Heaters":0,
            "Rice Cookers":0,
            "Other Cookers":0,
            "Steamers":0,
            "Coffee Makers":0,
            "Ovens":0,
            "Other Kitchen Electronics":0
        },
    },

    "Lighting & Electrical":{
        "Lighting":{
            "Indoor Lighting":0,
            "Outdoor Lighting":0,
            "Ceiling Fans":0,
            "Light Bulbs":0,
            "LED Lighting":0,
            "Ceiling Lights":0,
            "Indoor Wall Lights":0,
            "Outdoor Wall Lights":0,
            "Torches & Work Lights":0,
            "Lighting Gifts":0,
            "Light Fixtures & Fittings":0,
            "Light Switches & Dimmers":0,
            "Lighting Clearance":0,
            "Other Lighting":0
        },  
        "Electrical":{
            "Door Bells":0,
            "Switches & Sockets":0,
            "Mounting Boxes":0,
            "Plugs":0,
            "Cable":0,
            "Consumer Units":0,
            "Electrical Tools & Supplies":0,
            "Multiway Adaptors":0,
            "Other Electrical":0
        },
    },

    "Household Supplies":{
        "Household Supplies":{
            "Flatware, Knives & Cutlery":0,
            "Dinnerware & Serving Dishes":0,
            "Cookware":0,
            "Bakeware":0,
            "Racks":0,
            "Basins":0, 
            "Plastic Items":0,
            "Glassware & Drinkware":0,
            "Vacuum Flasks & Mugs":0,
            "Mops & Brooms":0,
            "Brushes & Dusters":0,
            "Other Household Supplies":0
        },
    },

    "Tiles & Bathware":{
        "Tiles":{ 
            "Wall Tiles":0,
            "Floor Tiles":0,
            "Mosaic & Border Tiles":0,
            "Bathroom Tiles":0,
            "Kitchen Tiles":0,
            "Wall & Floor Tiles":0,
            "Outdoor Tiles":0,
            "Decking Tiles":0,
            "Other Tiles":0
        },
        "Bathware":{
            "Bathroom Suites":0,
            "Furniture & Cabinets":0,
            "Enclosures,Doors & Trays":0,
            "Showers & Accessories":0,
            "Baths, Panels & Screens":0,
            "Toilets":0,
            "Basins":0,
            "Bathroom Taps":0,
            "Bathroom Accessories":0,
            "Toilet Seats":0,
            "Bathroom Wall Panels":0,
            "Other Bathware":0
        },
    },

    "Outdoor":{
        "Outdoor":{
            "Garden Décor Items":0,
            "Garden Fencing Supplies":0,
            "Garden Structures":0,
            "Shade Equipment":0,
            "Gardening Supplies":0,
            "Garden Furniture":0,
            "Gates":0,
            "Lawn Mowers":0,
            "Outdoor Cooking Equipment":0,
            "Outdoor Power Equipment":0,
            "Garden Furniture":0,
            "Outdoor Ponds":0,
            "Water Features":0,
            "Other Yard & Outdoor Items":0,
            "Other Outdoor":0
        },
    },

    "Furniture":{
        "Living Room Furniture":{
            "Sofas":0,
            "Drawer And Cabinets":0,
            "Benches":0,
            "Tv Media Stands":0,
            "Tables":0,
            "Racks":0,
            "Chairs":0,
            "Stools":0,
            "Ottomans":0,
            "Stand":0,
            "Cart And Easels":0,
            "Wine Racks And Cabinet":0,
             "Other Living Room Furniture":0

        },
        "Bedroom Furniture":{
            "Bed Trays":0,
            "Beds":0,
            "Headboard":0,
            "Pillows":0,
            "Mattresses":0,
            "Bedroom Sets":0,
            "Sheets And Curtains":0,
            "Rugs And Mats":0,
            "Other Bedroom Furniture":0
        },
        "Office Furniture":{
            "Home Office Desks":0,
            "Office Accessory":0,
            "Bookcase And Shelf":0,
            "Office Products":0,
            "Bookcase":0,
            "Other Office Furniture":0
        },
        "Other Furniture":{
            "Medical Furniture":0,
            "Medical Equipment":0,
            "Kid Furniture":0,
            "Other Furniture":0
        },
        
    },

    "Handicrafts":{
        "Clothes,Fabrics & Accessories":{
                "Batik":0,
                "Handloom":0,
                "Weaving":0,
                "Tatting":0,
                "Macramé":0,
                "Crochet":0,
                "Tapestry":0,
                "Other":0
        },
        "Leather":{
                "Bags & pouches":0,
                "Basket Weaving":0,
                "Other":0
        },
        "Stone & Metal":{ 
            "Jewellery":0,
            "Brass":0,
            "Oxidised":0,
            "Silver":0,
            "Copper":0,
            "Other":0
        },      
        "Wood":{
            "Woodworks":0,
            "Furniture":0,
            "Other":0
        },
        "Clay,Glass & Ceramics":{
            "Mosaic":0,
            "Cameo Glass":0,
            "Porcelain":0,
            "Pottery":0,
            "Other":0
        },
        "Paintings":{
            "Paintings":0,
            "Other":0
        },
        "Sea Shells":{
            "Sea Shells":0,
            "Other":0
        },
        "Paper Crafts":{
            "Paper Marbling":0,
            "Origami":0,
            "Papier-Mâché":0,
            "Calligraphy":0,
            "Decoupage & Quilling":0,
            "Other":0
        },      
    },

    "Health & Beauty":{
        "Health & Beauty":{
            "Makeup":0,
            "Men’s Perfume":0,
            "Women’s Perfume":0,
            "Skin Care":0,
            "Nail Care":0,
            "Hair Care":0,
            "Health Care":0,
            "Other Health & Beauty":0
        },
    },

    "Fancy Items":{
        "Health & Beauty":{
            "Makeup":0,
            "Men’s Perfume":0,
            "Women’s Perfume":0,
            "Skin Care":0,
            "Nail Care":0,
            "Hair Care":0,
            "Health Care":0,
            "Other Health & Beauty":0
        },
        "Fancy Items":{
            "Bags":0,
            "Jewelrys":0,
            "Shoes":0,
            "Clothing":0,
            "Other Fancy Items":0
        }
    },

    "Home Decoration":{
        "Home Decoration":{
            "Clocks":0,
            "Candle Holders":0,
            "Picture Frames":0,
            "Vases":0,
            "Mirrors":0,
            "Decor Accessories":0,
            "Wall Art":0,
            "Wall Decor":0,
            "Home & Kitchen":0,
            "Blinds And Shades":0,
            "Christmas Tree":0,
            "Sculptures":0,
            "Other Home Decoration":0
        },
    },

    "Window Treatments":{
        "Window Treatments":{
            "Curtain, Blinds & Shades":0,
            "Curtain Rods & Finials":0,
            "Other Window Treatments":0,
            "Beddings":0,
            "Rugs & Carpets":0,
            "Cushions & Throws":0,
            "Other Window Treatments":0
        },
    },

    "Jewelry & Watches":{
        "Women’s Jewelry":{
            "Rings":0,
            "Necklace & Pendants":0,
            "Earrings":0,
            "Bracelets":0,
            "Anklets":0,
            "Body Jewelry":0,
            "Hair & Head Jewelry":0,
            "Jewelry Sets":0,
            "Toe Rings":0,
            "Other Women’s Jewelry":0
        },
                
        "Men’s Jewelry":{
            "Rings":0,
            "Chains, Necklaces & Pendants":0,
            "Bracelets":0,
            "Cufflinks":0,
            "Earrings, Studs":0,
            "Lapel Pins":0,
            "Tie Clasps & Tacks":0,
            "Other Men’s Jewelry":0
        },

        "Engagement & Wedding":{
            "Engagement Rings":0,
            "Engagement & Wedding Ring Sets":0,
            "Wedding & Anniversary Bands":0,
            "Wedding party Jewelry":0
        },

        "Kids Watches":{
            "Analog":0,
            "Digital":0,
            "Smart":0,
            "Chronograph":0,
             "Other Kids Watches":0
        },
        "Mens Watches":{
            "Analog":0,
            "Digital":0,
            "Smart":0,
            "Chronograph":0,
             "Other Mens Watches":0
        },  
        "Ladies Watches":{
            "Analog":0,
            "Digital":0,
            "Smart":0,
            "Chronograph":0,
             "Other Ladies Watches":0
        },
        "Couple Watches":{
            "Analog":0,
            "Digital":0,
            "Smart":0,
            "Chronograph":0,
             "Other Couple Watches":0
        },

    },

    "Watches":{
        "Kids Watches":{
            "Analog":0,
            "Digital":0,
            "Smart":0,
            "Chronograph":0,
             "Other Kids Watches":0
        },
        "Mens Watches":{
            "Analog":0,
            "Digital":0,
            "Smart":0,
            "Chronograph":0,
             "Other Mens Watches":0
        },  
        "Ladies Watches":{
            "Analog":0,
            "Digital":0,
            "Smart":0,
            "Chronograph":0,
             "Other Ladies Watches":0
        },
        "Couple Watches":{
            "Analog":0,
            "Digital":0,
            "Smart":0,
            "Chronograph":0,
             "Other Couple Watches":0
        },
    },

    "Jewelry":{
        "Women’s Jewelry":{
            "Rings":0,
            "Necklace & Pendants":0,
            "Earrings":0,
            "Bracelets":0,
            "Anklets":0,
            "Body Jewelry":0,
            "Hair & Head Jewelry":0,
            "Jewelry Sets":0,
            "Toe Rings":0,
            "Other Women’s Jewelry":0
        },
                
        "Men’s Jewelry":{
            "Rings":0,
            "Chains, Necklaces & Pendants":0,
            "Bracelets":0,
            "Cufflinks":0,
            "Earrings, Studs":0,
            "Lapel Pins":0,
            "Tie Clasps & Tacks":0,
            "Other Men’s Jewelry":0
        },

        "Engagement & Wedding":{
            "Engagement Rings":0,
            "Engagement & Wedding Ring Sets":0,
            "Wedding & Anniversary Bands":0,
            "Wedding party Jewelry":0
        },
    },

    "Mobiles & Tablets":{
        "Mobiles":{
            "Acer":0,
            "Ag-tel":0,
            "Alcatel":0,
            "Apple":0,
            "Asus":0,
            "BenQ":0,
            "BlackBerry":0,
            "Dialog":0,
            "E-tel":0,
            "Google":0,
            "Greentel":0,
            "HTC":0, 
            "Huawei":0, 
            "Lenovo":0,
            "LG":0,
            "Micromax":0,
            "Microsoft":0,
            "Moto":0,
            "Nokia":0,
            "OnePlus":0,
            "Oppo":0,
            "Samsung":0,
            "Sky":0,
            "Sony Ericsson":0,
            "Sony":0,
            "Vivo":0,
            "Xiaomi":0,
            "Zigo":0,
            "ZTE":0,
            "Other Mobile":0

        },

        "Tablets":{
            "Acer Tablet":0,
            "Amazon Tablet":0,
            "Apple Tablet":0,
            "ASUS Tablet":0,
            "Dialog Tablet":0,
            "HP Tablet":0,
            "Huawei Tablet":0,
            "Microsoft Tablet":0,
            "Samsung Tablet":0,
            "Other Tablet":0
        },

        "Accessories":{
            "Headsets":0,
            "Audio Docks & Speakers":0, 
            "Cases, Covers & Skins":0,
            "Screen Protectors":0,
            "Chargers & Cradles":0,
            "Batteries":0,
            "Cable & Adapters":0,
            "Memory Cards":0,
            "Other Accessories":0
        },
    },

    "Music":{
        "Musicle Instruments":{
            "Guitars":0,
            "Ukuleles":0,
            "Amps & Effects":0,
            "Drums and Percussion":0,
            "DJ & Karaoke":0,
            "Keyboards & Midi":0,
            "Microphones":0,
            "Headphones":0,
            "Studio Recording":0,
            "Live Sound & Stage":0,
            "Brass":0,
            "Strings":0,
            "Winds & Woodwinds":0,
            "Accessories":0,
            "Other Musicle Instruments":0
        },
    },

    "Sports":{
        "Sports Nutrition":{
            "Supplements":0,
            "Fat Burners":0,
            "Other Sports Nutrition":0
        },
        "Sports Equipment":{
            "Cricket":0, 
            "Badminton":0, 
            "Swimming":0,
            "Running":0,
            "Cycling":0,
            "Camping & Hiking":0,
            "Basketball":0, 
            "Netball":0, 
            "Skates":0, 
            "Tennis":0,
            "Other Sports Equipment":0
        },
        "Fitness Equipment":{
            "Treadmills":0,
            "Dumbbells":0,
            "Ab Exercisers":0,
            "Skipping Ropes":0, 
            "Balls":0, 
            "Bars":0, 
            "Fitness Accessories":0, 
            "Kits":0, 
            "Mats":0, 
            "Bottles & Shakers":0,
            "Gloves":0,
            "Other Fitness Equipment":0
        },
        "Sports Clothing":{
            "T-Shirts":0,
            "Shorts":0,
            "Shoes":0, 
            "Bags":0,
            "Other Sports Clothing":0
        
        },
        
    },

    "Shoes & Footwear":{
        "Women’s Shoes":{
            "Heels":0,
            "Flats & Oxfords":0,
            "Occupational":0,
            "Sandals & Flip Flops":0,
            "Slippers":0,
            "Athletic":0,
             "Other Women’s Shoes":0
        },

        "Men’s Shoes":{
            "Dress Formal Shoes":0,
            "Casual":0,
            "Sandals & Flip Flops":0,
            "Slippers":0,
            "Boots":0,
            "Athletic":0,
             "Other Men’s Shoes":0

        },

        "Kids & Baby Shoes":{
            "Girls":0,
            "Boys":0
        },

    },

    "Tools & Machines":{
        "Tools & Machines":{
            "Air Tools":0,
            "Hand Tools":0,
            "Power Tools":0,
            "Tool Boxes":0,
            "Ladders":0,
            "Generators":0,
            "Air Compressors":0,
            "Welding & Soldering Tools":0,
            "Safety & Protective Gear":0,
            "Other Tools & Machines":0
        },
        "Machines":{
            "Industrial Machines":0,
             "Other Machines":0
        },
    },

    "Vehicles":{
        "Agriculture Machinery":{
            "Massey Ferguson":0,
            "Photon":0,
            "John Deere":0,
            "Tafe":0,
            "Kubota":0, 
            "Mahindra":0,
            "Other Agriculture Machinery":0
        },

        "Bus":{
            "Ashok Leyland":0,
            "Tata":0, 
            "Micro":0, 
            "Mercedes":0,
            "Mitsubishi":0, 
            "Isuzu":0, 
            "Toyota":0, 
            "Star Bus":0,
            "Ssangyong":0, 
            "Other Bus":0
        },

        "Car":{
            "Alfa":0, 
            "Aston Martin":0,
            "Audi":0, 
            "Austin":0,
            "BMW":0,
            "Cherry":0,
            "Chevrolet":0, 
            "Chrysler":0,
            "Daewoo":0, 
            "Daihatsu":0, 
            "Datsun":0, 
            "DFSK":0, 
            "Dodge":0, 
            "Ferrari":0,
            "Fiat":0, 
            "Ford":0, 
            "Hillman":0,
            "Honda":0, 
            "Hummer":0, 
            "Hyundai":0, 
            "Isuzu":0, 
            "Jaguar":0,
            "Jeep":0, 
            "KIA":0, 
            "Lamborghini":0,
            "Land Rover":0, 
            "Lexus":0, 
            "Mahindra":0, 
            "Skoda":0,
            "Suzuki Maruti":0, 
            "Mazda":0,
            "Mangustan":0, 
            "MCLaren":0, 
            "Mercedes":0, 
            "Micro":0, 
            "Mini":0,
            "Mitsubishi":0, 
            "Morris":0, 
            "Nissan":0, 
            "Opel":0,
            "Perodua":0, 
            "Peugeot":0, 
            "Plymouth":0, 
            "Porsche":0, 
            "Proton":0, 
            "Renault":0, 
            "Rover":0, 
            "Royal Enfield":0,
            "Rolls Royce":0,  
            "Saab":0,
            "Scion":0,
            "Skoda":0,
            "Subaru":0, 
            "Suzuki":0, 
            "Tata":0, 
            "Tesla":0, 
            "Toyota":0, 
            "Vauxhall":0, 
            "Volkswagen":0, 
            "Volvo":0, 
            "Zotye":0, 
            "Other Car":0
        },

        "Crew Cab":{
            "Mitsubishi":0,
            "Toyota":0,
            "Nissan":0,
            "Isuzu":0,
            "FAW":0,
            "KIA":0,
            "JAC":0,
            "JMC":0,
            "Mazda":0,
            "Changan":0,
            "Dongfeng":0, 
            "ATCO":0,
            "Hyundai":0,
            "Foton":0,
            "Micro":0,
            "Ssangyong":0, 
            "Other Crew Cab":0

        },

        "Heavy-Duty & Land Vehicle":{
            "Isuzu":0, 
            "Mitsubishi":0, 
            "Man":0,
            "Sinotruk":0, 
            "Mercedes":0, 
            "Hino":0, 
            "Tata":0, 
            "John Deere":0, 
            "Cobelco":0, 
            "Hitachi":0, 
            "Volvo":0, 
            "Sumitomo":0, 
            "Komatsu":0, 
            "Perkins":0, 
            "Yanmar":0, 
            "Hyundai":0, 
            "DAF":0,
            "IVECO":0,
            "Howo":0, 
            "Ashok Leyland":0,
            "SANY":0,
            "Kawasaki":0, 
            "BOMAG":0,
            "Nissan":0, 
            "JCB":0,
            "Kubota":0, 
            "Mahindra":0, 
            "Massey Ferguson":0,
            "Caterpillar":0, 
            "New Holland":0,
            "Bobcat":0,
            "TCM":0,
            "Ford":0, 
            "Eicher":0,
            "Sakai":0, 
            "Benford":0, 
            "Furukawa":0, 
            "DFAC":0,
            "Tadana":0, 
            "Toyota":0, 
            "Other Heavy-Duty & Land Vehicle":0

        },

        "Jeep & Picup":{
            "Audi":0,
            "BMW":0,
            "Chevrolet":0,
            "Daewoo":0,
            "Daihatsu":0,
            "Datsun":0,
            "DFSK":0,
            "Ford":0,
            "GMC":0,
            "Honda":0,
            "Hummer":0,
            "Hyundai":0,
            "Isuzu":0,
            "Jeep":0,
            "Foton":0, 
            "Kia":0,    
            "Land Rover":0,
            "Lexus":0,
            "Mahindra":0,
            "Suzuki Maruti":0,
            "Mazda":0,
            "MCLaren":0,
            "Mercedes":0,
            "Micro":0,
            "Mitsubishi":0,
            "Nissan":0,
            "Perodua":0,
            "Peugeot":0,
            "Porsche":0,
            "Renault":0,
            "Rolls Royce":0,
            "Subaru":0,
            "Skoda":0,
            "Suzuki":0,
            "Tata":0,
            "Tesla":0,
            "Toyota":0,
            "Vauxhall":0,
            "Volkswagen":0,
            "Volvo":0,
            "Willys":0,
            "Zotye":0,
            "Other Jeep & Picup":0

        },

        "Lorry":{
            "Ashok Leland":0, 
            "Changan":0,
            "DFAC":0,
            "Mitsubishi":0,
            "Isuzu":0, 
            "Tata":0, 
            "Toyota":0, 
            "JAC":0,
            "JMC":0,
            "JVC":0,
            "Eicher":0, 
            "FAW":0,
            "Foton":0, 
            "Ford":0, 
            "Hino":0, 
            "KIA":0,
            "Mahindra":0, 
            "Mazda":0,
            "Nissan":0, 
            "Honda":0, 
            "Dimo":0, 
            "Daihatsu":0, 
            "Suzuki":0, 
            "Micro":0, 
            "Freight Rover":0,  
            "Unimo":0, 
            "Youjin":0, 
            "MAN":0, 
            "DFSK":0,
            "Subaru":0, 
            "Other Lorry":0 
        },

        "Motorcycle":{
            "Aprilla":0, 
            "Bajaj":0,
            "BMW":0,
            "Demak":0,
            "Ducati":0,
            "Ceygra":0, 
            "Cagiva":0,
            "Chans":0,  
            "Singer":0,
            "Harley Davidson":0,
            "Hero Honda":0,
            "Honda":0,
            "Husqvarna":0,
            "Hyosung":0, 
            "Jialing":0, 
            "Kawasaki":0,
            "Kinetic":0,
            "KTM":0,
            "DFSK":0,
            "SsangYong":0,
            "TVS":0,
            "Triumph":0, 
            "Loncin":0,
            "Mahindra":0,
            "Minnelli":0,
            "Moto Guzzi":0,
            "Piaggio":0, 
            "Ranamoto":0,
            "Royal Enfieid":0,
            "Suzuki":0,
            "Triumph":0,
            "Vespa":0,
            "Yamaha":0,
            "Yoshimura":0, 
            "Zhongneng":0, 
            "Other Motorcycle":0

        },

        "Three Wheeler":{
            "TVS":0,
            "Bajaj":0,
            "Mahindra":0,
            "Ceygra":0, 
            "Piaggio":0,
            "Other Three Wheeler":0  
        },

        "Tipper":{
            "Ashok Leyland":0, 
            "Tata":0, 
            "Hino":0, 
            "Isuzu":0, 
            "Mitsubishi":0,
            "MAN":0,
            "Youjin":0, 
            "Eicher":0,
            "JAC":0,
            "Mazda":0, 
            "ATCO":0,
            "Mahindra":0, 
            "Nissan":0, 
            "Toyota":0, 
            "Changan":0, 
            "Sojen":0, 
            "Other Tipper":0 

        },

        "Truck":{
            "Tata":0, 
            "Mahindra":0, 
            "DFSK":0,
            "GMC":0,
            "Micro":0, 
            "Suzuki":0, 
            "Nissan":0, 
            "Honda":0, 
            "Daihatsu":0, 
            "Subaru":0,
            "Isuzu":0,
            "Mitsubishi":0, 
            "Other Truck":0
        },

        "Van":{
            "FAW":0,
            "Ford":0,
            "Daihatsu":0,
            "Dimo":0,
            "Honda":0,
            "Hyundai":0,
            "Isuzu":0,
            "Kia":0,
            "Mazda":0,
            "Mercedes":0,
            "Mitsubishi":0,
            "Micro":0,
            "DFSK":0,
            "Nissan":0,
            "Subaru":0,
            "Suzuki":0,
            "Tata":0,
            "Toyota":0,
            "Volvo":0,
            "Austin":0,
            "Other Van":0 

        },

    },

    "Men’s & Women’s Clothing":{
       "Men’s Clothing": {
            "T-Shirts":0,
            "Shirts":0,
            "sarongs":0,
            "Swimwear":0,
            "Denim & Jeans":0,
            "Pants":0,
            "Shorts":0,
            "Coats & Jackets":0,
            "Athletic Apparel":0,
            "Socks":0,
            "Underwear":0,
            "Sleep & Lounge":0,
            "Office Ware":0,
            "Other Men’s Clothing":0

        },
            

        "Women’s Clothing": {
            "Frocks":0,
            "Sarees":0,
            "Tops & Blouses":0,
            "T- Shirts":0,
            "Office Ware":0,
            "Coats & Jackets":0,
            "Denim & Jeans":0,
            "Party Dresses":0,
            "Shorts":0,
            "Skirts":0,
            "Swimwear":0,
            "Intimates & Sleepwear":0,
            "Other Women’s Clothing":0 

        },


        "Kids & Baby": {
            "Girls (newborn)":0,
            "Girls" :0,
            "Boys (newborn)":0,
            "Boys":0


        },

        "Men’s Accessories":{
            "Sunglasses":0,
            "Wallets":0,
            "Scarves & Wraps":0,
            "Watches":0,
            "Belts":0,
            "Hats":0,
            "Caps":0,
            "Gloves & Mittens":0,
             "Shoes":0,
            "Slippers":0,
            "Bags":0,
            "Jewelries":0,
            "Beauty":0,
            "Other Men’s Accessories":0,        

        },

        "Women’s Accessories":{
            "Sunglasses":0,
            "Wallets":0,
            "Scarves & Wraps":0,
            "Watches":0,
            "Belts":0,
            "Hats":0,
            "Caps":0,
            "Gloves & Mittens":0,
             "Shoes":0,
            "Slippers":0,
            "Bags":0,
            "Jewelries":0,
            "Beauty":0,
            "Other Women’s Accessories":0,  

        },

    },

    "Men’s Clothing":{
        "Men’s Clothing": {
            "T-Shirts":0,
            "Shirts":0,
            "sarongs":0,
            "Swimwear":0,
            "Denim & Jeans":0,
            "Pants":0,
            "Shorts":0,
            "Coats & Jackets":0,
            "Athletic Apparel":0,
            "Socks":0,
            "Underwear":0,
            "Sleep & Lounge":0,
            "Office Ware":0,
            "Other Men’s Clothing":0

        },
        
        "Kids & Baby": {
             "Girls (newborn)":0,
            "Girls" :0,
            "Boys (newborn)":0,
            "Boys":0


        },

        "Men’s Accessories":{
           "Sunglasses":0,
            "Wallets":0,
            "Scarves & Wraps":0,
            "Watches":0,
            "Belts":0,
            "Hats":0,
            "Caps":0,
            "Gloves & Mittens":0,
             "Shoes":0,
            "Slippers":0,
            "Bags":0,
            "Jewelries":0,
            "Beauty":0,
            "Other Men’s Accessories":0,      

        },
   
    },

    "Women’s Clothing":{
        "Women’s Clothing": {
             "Frocks":0,
            "Sarees":0,
            "Tops & Blouses":0,
            "T- Shirts":0,
            "Office Ware":0,
            "Coats & Jackets":0,
            "Denim & Jeans":0,
            "Party Dresses":0,
            "Shorts":0,
            "Skirts":0,
            "Swimwear":0,
            "Intimates & Sleepwear":0,
            "Other Women’s Clothing":0 

        },


        "Kids & Baby": {
            "Girls (newborn)":0,
            "Girls" :0,
            "Boys (newborn)":0,
            "Boys":0


        },

        "Women’s Accessories":{
           "Sunglasses":0,
            "Wallets":0,
            "Scarves & Wraps":0,
            "Watches":0,
            "Belts":0,
            "Hats":0,
            "Caps":0,
            "Gloves & Mittens":0,
             "Shoes":0,
            "Slippers":0,
            "Bags":0,
            "Jewelries":0,
            "Beauty":0,
            "Other Women’s Accessories":0,   

        },

    },
}



// WEBPACK FOOTER //
// ./src/data/categories.js